import * as React from 'react';
import cx from 'classnames';
import shallowCompare from 'react-addons-shallow-compare';
import Button from 'components/Button';
import Glyph from 'components/Glyph';
import Input from 'components/Input';
import KeyConstants from 'constants/KeyConstants';
import Label from 'components/Label';
import { InputChangeHandler, KeyboardEventHandler } from 'types/typescript/eventHandlers';

type Props = {
  className: string;
  onDismiss: () => void;
  onQueryChange: (query: string) => void;
  label: string;
};

type State = {
  value: string;
};

export default class SearchBlock extends React.Component<Props, State> {
  state = {
    value: '',
  };

  shouldComponentUpdate(nextProps: Object, nextState: Object): boolean {
    return shallowCompare(this, nextProps, nextState);
  }

  handleClose = () => {
    const { onDismiss, onQueryChange } = this.props;

    const value = '';

    this.setState({ value });

    // REVISIT should the caller have the freedom to preserve the last value?
    onQueryChange(value);

    if (onDismiss) {
      onDismiss();
    }
  };

  handleInputBlur = () => {
    const isEmpty = this.state.value.length === 0;

    if (isEmpty) {
      this.handleClose();
    }
  };

  handleInputChange: InputChangeHandler = event => {
    const { value } = event.target;

    this.setState({ value });

    this.props.onQueryChange(value);
  };

  handleInputKeyDown: KeyboardEventHandler = event => {
    const { keyCode } = event;
    switch (keyCode) {
      case KeyConstants.ESCAPE:
        this.handleClose();
        break;
      default:
        return;
    }
    event.preventDefault();
  };

  render() {
    const { className, label, ...others } = this.props;
    const { value } = this.state;
    const showClose = value && value.length > 0;

    const closeButton = (
      <Button aria-label="Clear search" level="icon" onClick={this.handleClose}>
        <Glyph name="close" size="small" solo />
      </Button>
    );

    return (
      <div className={cx('SearchBlock', className)}>
        <Label hidden>{label}</Label>
        <Input
          append={showClose && closeButton}
          glyph="search"
          placeholder={label}
          type="text"
          value={value || ''}
          onBlur={this.handleInputBlur}
          onChange={this.handleInputChange}
          onKeyDown={this.handleInputKeyDown}
          {...others}
        />
      </div>
    );
  }
}
